import { BaseService } from './base.service';

export class CheckOrdersService extends BaseService {
  static get resourceEndpoint() {
    return 'check_orders';
  }
}